/*eslint-env jquery*/
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { toastr } from 'react-redux-toastr'
import MySweetAlert from '../../Shared/MySweetAlert'
import Loading from '../../Shared/Loading'
import OperationIcon from '../../Shared/OperationIcon'
// import Select from 'react-select'
import { unitTasksService } from '../../../_services/unitTasks.service'
import DatePicker from '../../Shared/DatePicker'
import { DecimalInput } from 'react-hichestan-numberinput'
import TaskCode from '../../Shared/TaskCode'
// import { FaPlus } from 'react-icons/fa'
import { FiEdit } from 'react-icons/fi'
import { FiTrash2 } from 'react-icons/fi'
import { GiMagnifyingGlass } from 'react-icons/gi'
import { MdPlaylistAddCheck, MdAdd } from 'react-icons/md'
import { Field, FastField, ErrorMessage, getIn, Formik } from 'formik'
// import config from '../../../config'
// import NumberFormat from 'react-number-format'
// import ImportExcel from './ImportExcel'
import measurementTypes from '../../../_constants/measurementTypes'
import Form from './Form'
import { Tabs, Tab } from 'react-bootstrap'
import { AsyncCategorySelect } from '../../Shared/AsyncCategorySelect'
import AsyncBrandSelect from '../../Shared/AsyncBrandSelect'

// Import React Table
import matchSorter from 'match-sorter'
import ReactTable from 'react-table'
//
import { Input } from 'antd'

import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
import DialogTitle from '@material-ui/core/DialogTitle'
import Fab from '@material-ui/core/Fab'
import { MdClose } from 'react-icons/md'
// import AsyncCategorySelect from '../../Shared/AsyncCategorySelect'
// import AsyncBrandSelect from '../../Shared/AsyncBrandSelect'

import moment from 'moment-jalaali'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const requestData = (pageSize, page, sorted, filtered, dto) => {
  // // console.log(dto)
  return new Promise(async (resolve, reject) => {
    // var dto = {};
    dto['pageSize'] = pageSize
    dto['page'] = page
    if (sorted && sorted.length > 0) {
      dto['sorted'] = sorted[0]
    }

    console.log(JSON.stringify(dto))

    var result = []
    await unitTasksService
      .getAllClum(JSON.stringify(dto))
      .then(res => {
        // // console.log(res)
        result = res.data
      })
      .catch(err => {
        // setTimeout(() => requestData(pageSize, page, sorted, filtered, dto), 5000);
        // // console.log(err);
      })

    setTimeout(() => resolve(result), 100)
  })
}

class DataTable extends Component {
  constructor(props, context) {
    super(props, context)

    var pageSize = parseInt(localStorage.getItem('pageSize'), 0)
    this.state = {
      initialItems: [],
      data: [],
      loading: false,
      confirmDeleteShow: false,
      requiredItem: 0,
      deleteItemIndex: 0,
      model: {},
      resetUpload: false,

      searchModal: false,
      pageSize: pageSize ? pageSize : 10,
      dto: {
        page: 0,
        pageSize: pageSize,
        unitTaskStatus: this.props.unitTaskStatus,
        sorted: { id: 'createdAt', desc: true }
      },
      totalRecords: 0
    }
  }

  fetchData = (state, instance) => {
    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({ loading: true })
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    requestData(
      state.pageSize,
      state.page,
      state.sorted,
      state.filtered,
      this.state.dto
    )
      .then(res => {
        console.log(res.data)

        if (res.data) {
          // var pageSize = res.data.result.length > state.pageSize ? state.pageSize : res.data.result.length;
          // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
          this.setState({
            data: res.data,
            // pages: res.totalPage,
            pages: Math.ceil(res.totalRecords / state.pageSize),
            totalRecords: res.totalRecords,
            loading: false,
            modal: false,
            searchModal: false,
            pageSize: state.pageSize
          })
        }
      })
      .catch(err => {
        // console.log(err);

        this.setState({ loading: false, searchModal: false })
      })
  }

  _handleSearch = e => {
    let searcjQery = e.target.value.toLowerCase(),
      displayedItems = this.state.initialItems.filter(el => {
        let searchValue = el.name.toLowerCase()
        return searchValue.indexOf(searcjQery) !== -1
      })
    this.setState({
      data: displayedItems
    })
  }

  _handleCancelSearch = e => {
    document.getElementById('searchInput').value = ''
    this.setState({
      data: this.state.initialItems
    })
  }

  handleFilterChange = () => {
    const current = this.reactTable.getResolvedState()

    if (current) {
      const recordsCount = current.sortedData.length
      this.setState({ recordsCount })
      // return false
      // console.log(recordsCount);
    }
  }

  handleSearch = values => {
    // console.log(values);

    this.setState({ loading: true })

    if (values) {
      // // Object.keys(values).length > 0 &&
      //   Object.entries(values)
      //     .reduce((acc, [key, value]) => {
      //       dto[key] = value
      //     })
      this.setState({ dto: values, page: 0 }, () => {
        // console.log(dto);
        this.table.fireFetchData()
      })
    }
  }

  handleShowAll = () => {
    var dto = {
      page: 0,
      pageSize: this.state.dto.pageSize,
      unitTaskStatus: this.props.unitTaskStatus,
      sorted: { id: 'createdAt', desc: true }
    }
    this.setState({ dto: dto }, () => {
      this.table.fireFetchData()
    })
  }

  // componentDidMount() {

  //   this.table.fireFetchData();

  // }

  handleModalCreate = () => {
    this.setState({
      modalHeading: 'ثبت کالای جدید',
      modal: true,
      model: { name: '', measurementType: '', image: '' }
    })
  }

  handleModalEdit = _model => {
    this.setState({ modal: true, model: _model })
  }

  handleModalHide = e => {
    var evt = e || window.event // IE compatibility
    if (evt.preventDefault) {
      evt.preventDefault()
    }
    this.setState({ modal: false, model: {} })
  }

  handleModalClose = () => {
    this.setState({ modal: false, model: {} }, () => {
      this.table.fireFetchData()
    })
  }

  handleSweetAlertHide = () => {
    this.setState({ confirmDeleteShow: false })
  }

  // getData() {
  //   this.setState({ loading: true });
  //   unitTasksService.getAllByCategoryType(this.props.categoryType)
  //     .then((res) => {
  //       console.log(res.data)
  //       this.setState({ initialItems: res.data, data: res.data, loading: false });
  //     })
  //     .catch((error) => {
  //       // console.log(error);
  //       this.setState({ loading: false });
  //     })
  // };

  handleError(error) {
    this.setState({ loading: false })
    // // toastr.warning('مشکلی پیش آمد', error);
  }

  handleDelete = e => {
    let _model = this.state.data[e]

    this.setState({ confirmDeleteShow: true, model: _model })
  }

  handleConfirmDelete = () => {
    this.setState({ loading: true, confirmDeleteShow: false })
    // console.log(this.state.model);
    unitTasksService
      .delete(this.state.model.id)
      .then(res => {
        toastr.success('حذف کالا ', 'کالا با موفقیت حذف شد')
        this.table.fireFetchData()
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  importFromExcel = values => {
    this.setState({ loading: true })

    values.splice(0, 1)
    var dto = []

    values.forEach(product => {
      var obj = {}

      if (product[0] && product[2]) {
        obj['extraCode'] = parseInt(product[0], 0)
        obj['quantity'] = parseInt(product[2], 0)

        dto.push(obj)
      }
    })

    // console.log(JSON.stringify(dto));

    unitTasksService
      .importFromExcel(JSON.stringify(dto))
      .then(res => {
        var updatedCount = res.data
        toastr.success('موجودی ' + updatedCount + ' کالا بروزرسانی شد')
        this.table.fireFetchData()
      })
      .catch(error => {
        // console.log(error);
        this.setState({ loading: false })
      })
  }

  render() {
    const { pageSize, data, pages, loading, searchModal } = this.state
    return (
      <div>
        <div className="row table-container" style={{ marginTop: 0 }}>
          <ReactTable
            manual
            data={data}
            pages={pages}
            loading={loading}
            onFetchData={this.fetchData}
            ref={instance => {
              this.table = instance
            }}
            sorted={this.state.sorted}
            onSortedChange={(newSort, column) => {
              this.setState({ sorted: newSort })
            }}
            onPageSizeChange={pageSize => {
              // const { dispatch } = this.props;
              // dispatch( setPageSize(pageSize) )
              localStorage.setItem('pageSizeForProjects', pageSize)
              // this.setState({ page: 0 });
            }}
            page={this.state.page}
            onPageChange={page => this.setState({ page })}
            defaultPageSize={pageSize}
            previousText="صفحه قبل"
            nextText="صفحه بعد"
            loadingText="در حال بارگذاری ..."
            noDataText="نتیجه ای یافت نشد"
            pageText="صفحه"
            ofText="از"
            rowsText="تعداد نمایش"
            // renderPageSizeOptions = ({ pageSize, pageSizeOptions, rowsSelectorText, onPageSizeChange, rowsText }) => { return (<select onChange={e => onPageSizeChange(Number(e.target.value))} value={pageSize} > {pageSizeOptions.map((option, i) => ( // eslint-disable-next-line react/no-array-index-key <option key={i} value={option}> {${option} ${{this.props.rowsText}}} </option> ))} </select>) }

            defaultFilterMethod={(filter, row) =>
              String(row[filter.id]) === filter.value
            }
            getTableProps={() => ({ style: { display: 'block' } })}
            getTrProps={(state, rowInfo, column, instance) => {
              const newSelected = Object.assign({}, this.state.selected)
              const selected = rowInfo
                ? newSelected[rowInfo.original.id]
                : false
              return {
                style: {
                  backgroundColor: selected && '#5079F7',
                  color: selected && 'white'
                }
              }
            }}
            columns={[
              {
                Header: 'ردیف',
                id: 'createdAt',
                maxWidth: 50,
                filterable: false,
                sortable: false,
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                className: 'numberFa',
                Cell: row => {
                  return row.page * row.pageSize + (row.index + 1)
                }
              },
              {
                Header: 'کد سفارش',
                accessor: 'taskCode',
                id: 'taskCode',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  overflow: 'visible',
                  justifyContent: 'center'
                },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, {
                    keys: ['product.name'],
                    threshold: matchSorter.rankings.CONTAINS
                  }),
                filterAll: true,
                Filter: ({ filter, onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                ),
                Cell: row => {
                  return <TaskCode code={row.original.taskCode} />
                }
              },
              {
                Header: 'نام کالا',
                accessor: 'product.name',
                id: 'name',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  overflow: 'visible',
                  justifyContent: 'center'
                },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, {
                    keys: ['product.name'],
                    threshold: matchSorter.rankings.CONTAINS
                  }),
                filterAll: true,
                Filter: ({ filter, onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                ),
                Cell: row => {
                  return (
                    row.original.product &&
                    row.original.product.category.name +
                      ' (' +
                      row.original.product.name +
                      ')'
                  )
                }
              },
              {
                Header: 'کد کالا',
                accessor: 'product.extraCode',
                id: 'extraCode',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  overflow: 'visible',
                  justifyContent: 'center'
                },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, {
                    keys: ['product.extraCode'],
                    threshold: matchSorter.rankings.CONTAINS
                  }),
                filterAll: true,
                Filter: ({ filter, onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                ),
                Cell: row => {
                  return row.original.product && row.original.product.extraCode
                }
              },
              // {
              //   Header: "کد کوتاه مواد اولیه",
              //   accessor: "shortExtraCode",
              //   id: "shortExtraCode",
              //   style: { display: 'flex', alignItems: 'center', overflow: 'visible', justifyContent: 'center' },
              //   filterMethod: (filter, rows) =>
              //     matchSorter(rows, filter.value, { keys: ["shortExtraCode"], threshold: matchSorter.rankings.CONTAINS }),
              //   filterAll: true,
              //   Filter: ({ filter, onChange }) =>
              //     <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />,

              // },
              {
                Header: 'دسته بندی',
                accessor: 'product.category.name',
                id: 'categoryId',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  overflow: 'visible',
                  justifyContent: 'center'
                },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, {
                    keys: ['product.category.name'],
                    threshold: matchSorter.rankings.CONTAINS
                  }),
                filterAll: true,
                Filter: ({ filter, onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                ),

                Cell: row =>
                  row.original.product && row.original.product.category.name
              },
              {
                Header: 'برند',
                accessor: 'brand',
                id: 'brandId',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  overflow: 'visible',
                  justifyContent: 'center'
                },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, {
                    keys: ['product.brand.name'],
                    threshold: matchSorter.rankings.CONTAINS
                  }),
                filterAll: true,
                Filter: ({ filter, onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                ),

                Cell: row =>
                  row.original.product && row.original.product.brand.name
              },
              // {
              //   Header: "میزان سفارش",
              //   id: "quantity",
              //   accessor: d => d.quantity,
              //   style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
              //   className: "numberFa",
              //   filterable: false,
              //   filterMethod: (filter, rows) =>
              //     matchSorter(rows, filter.value, { keys: ["quantity"], threshold: matchSorter.rankings.CONTAINS }),
              //   filterAll: true,
              //   Filter: ({ filter, onChange }) =>
              //     <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />,
              //   Cell: row => (
              //     row.original.quantity + (row.original.product.measurementType !== undefined ? ' (' + measurementTypes.filter(el => el.value === row.original.product.measurementType)[0].label + ')' : '')
              //   )
              // },
              // {
              //   Header: "موجودی (بسته)",
              //   id: "quantity",
              //   accessor: d => d.quantity,
              //   style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
              //   className: "numberFa",
              //   filterMethod: (filter, rows) =>
              //     matchSorter(rows, filter.value, { keys: ["quantity"], threshold: matchSorter.rankings.CONTAINS }),
              //   filterAll: true,
              //   Filter: ({ filter, onChange }) =>
              //     <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />,
              //   Cell: row => (
              //     row.original.conversionUnit && row.original.quantity ?
              //       <div>{Math.floor(row.original.quantity / row.original.conversionUnit)}</div>
              //       :
              //       <div>0</div>
              //   )
              // },
              // {
              //   Header: "قیمت",
              //   id: "price",
              //   accessor: d => d.price,
              //   style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
              //   minWidth: 120,
              //   className: "numberFa",
              //   filterAll: true,
              //   filterMethod: (filter, rows) =>
              //     matchSorter(rows, filter.value, { keys: ["price"], threshold: matchSorter.rankings.CONTAINS }),
              //   Filter: ({ filter, onChange }) =>
              //     <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />,
              //   Cell: props => (
              //     <NumberFormat thousandSeparator={true}
              //       className="numberFa"
              //       value={props.original.price}
              //       displayType="text"
              //       suffix="ریال"
              //     />
              //   )
              // },
              // {
              //   Header: "ضریب متراژ",
              //   id: "conversionUnit",
              //   accessor: d => d.conversionUnit,
              //   style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
              //   className: "numberFa",
              //   filterMethod: (filter, rows) =>
              //     matchSorter(rows, filter.value, { keys: ["conversionUnit"], threshold: matchSorter.rankings.CONTAINS }),
              //   filterAll: true,
              //   Filter: ({ filter, onChange }) =>
              //     <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />,

              // },
              {
                Header: 'تاریخ ثبت',
                accessor: 'createdAt',
                id: 'createdAt',
                filterable: false,
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, {
                    keys: ['createdAt'],
                    threshold: matchSorter.rankings.CONTAINS
                  }),
                filterAll: true,
                Filter: ({ onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                ),
                Cell: row =>
                  moment(row.original.createdAt, 'YYYY/M/D H:m').format(
                    'jYYYY/jM/jD ساعت H:mm'
                  )
              },
              {
                Header: 'مشاهده و ارجاع',
                accessor: 'id',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                sortable: false,
                filterable: false,
                show: this.props.unitTaskStatus === 0 ? true : false,
                // Filter: ({ filter, onChange }) =>
                //   <div className="btns-group">
                //     <a onClick={() => this.handleModalCreate(1)} className="btn btn-primary react-table-add-btn" >
                //       <span>
                //         <FaPlus size="16px" />
                //         افزودن فرآیند تولید جدید
                // </span>
                //     </a>
                //     {/* <ImportExcel onChange={(val) => this.importFromExcel(val)} /> */}
                //   </div>
                // ,
                Cell: row => (
                  <div>
                    <a
                      className="btn btn-sm btn-simple btn-success bmd-ripple bmd-flat-btn"
                      onClick={() => this.handleModalEdit(row.original)}>
                      <OperationIcon
                        size="24px"
                        color="#0063d1"
                        className="btn btn-sm btn-simple btn-danger bmd-ripple bmd-flat-btn delete-btn"
                      />
                      {/* <FiEdit size="24px" /> */}
                    </a>
                    {/* <a onClick={() => this.handleDelete(row.index)}data-original-title="حذف" rel="tooltip"><FiTrash2 size="24px" /></a> */}
                  </div>
                )
              }
            ]}
            className="-striped -highlight">
            {(state, makeTable, instance) => {
              let recordsInfoText = ''

              const {
                filtered,
                pageRows,
                pageSize,
                sortedData,
                page,
                data
              } = state

              if (sortedData && sortedData.length > 0) {
                let isFiltered = filtered.length > 0

                let totalRecords = sortedData.length

                let totalDataCount = data.length

                let recordsCountFrom = page * pageSize + 1

                let recordsCountTo = recordsCountFrom + pageRows.length - 1

                if (isFiltered)
                  recordsInfoText = `${totalRecords} از ${totalDataCount} نتیجه فیلتر شده`
                else recordsInfoText = `تعداد کل: ${totalRecords}`
              } else recordsInfoText = 'نتیجه ای یافت نشد'

              return (
                <>
                  <div className="row text-right">
                    <div className="col-sm-12">
                      <div className="react-table-top-area">
                        <span className="records-info">{`تعداد کل: ${
                          this.state.totalRecords
                        }`}</span>

                        {/* <ImportExcel onChange={(val) => this.importFromExcel(val)} /> */}
                        <div>
                          <a
                            onClick={() => this.handleShowAll()}
                            className="btn btn-primary pull-left btn-sm"
                            disabled={loading}
                            style={{ margin: 0, marginLeft: 5 }}>
                            <MdPlaylistAddCheck
                              size="20px"
                              style={{ verticalAlign: 'middle' }}
                            />
                            &nbsp;نمایش همه
                          </a>

                          <a
                            onClick={() =>
                              this.setState({
                                modalHeading: 'جستجو',
                                searchModal: true
                              })
                            }
                            className="btn btn-sm btn-primary pull-left"
                            style={{ margin: 0, marginLeft: 5 }}
                            disabled={loading}>
                            <GiMagnifyingGlass
                              size="20px"
                              style={{ verticalAlign: 'middle' }}
                            />
                            &nbsp;جستجو
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="clearfix" />
                    <br />
                  </div>
                  {makeTable()}
                </>
              )
            }}
          </ReactTable>
        </div>

        <Dialog
          open={searchModal && !loading}
          TransitionComponent={Transition}
          fullWidth={true}
          maxWidth="xs"
          onClose={() => this.setState({ searchModal: false })}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          // style={{ overflow: 'visible' }}
        >
          <DialogTitle>
            <Fab
              color="secondary"
              aria-label="refresh"
              size="small"
              onClick={() => this.setState({ searchModal: false })}
              className="modal-close-btn">
              <MdClose
                size="20px"
                className={loading ? 'mdi-spin mdi-loading' : ''}
              />
            </Fab>
          </DialogTitle>
          <DialogContent className="search-modal">
            {loading && <Loading />}

            <Formik
              enableReinitialize
              initialValues={this.state.dto}
              onSubmit={(values, { setSubmitting }) => {
                // // console.log(values);
                this.handleSearch(values)
                setSubmitting(false)
              }}
              // validationSchema={ValidationSchema}
            >
              {props => {
                const {
                  values,
                  touched,
                  errors,
                  isSubmitting,
                  handleChange,
                  handleBlur,
                  setFieldValue,
                  handleSubmit,
                  resetForm
                } = props
                return (
                  <div className="row" style={{ position: 'relative' }}>
                    <div className="col-md-12">
                      <form onSubmit={handleSubmit}>
                        {/* {JSON.stringify(values)} */}

                        <div className="row">
                          <div className="form-inline search-container">
                            <div className="col-lg-12 col-sm-12">
                              <label>دسته بندی</label>
                              <AsyncCategorySelect
                                clearable
                                categoryType={this.props.categoryType}
                                defaultValue={values.categoryId}
                                onChange={val => {
                                  setFieldValue(
                                    'categoryId',
                                    val ? val : undefined
                                  )
                                }}
                                className="semantic-select-box"
                              />
                            </div>

                            <div className="col-lg-12 col-sm-12">
                              <label>برند</label>
                              <AsyncBrandSelect
                                clearable
                                brandType={
                                  this.props.categoryType === 0 ? 0 : 1
                                }
                                defaultValue={values.brandId}
                                onChange={val => {
                                  setFieldValue(
                                    'brandId',
                                    val ? val : undefined
                                  )
                                }}
                                className="semantic-select-box"
                              />
                            </div>

                            <div className="col-lg-12 col-sm-12">
                              <label>نام کالا</label>

                              <input
                                type="text"
                                onChange={e => {
                                  setFieldValue('name', e.target.value)
                                }}
                                value={values && values.name ? values.name : ''}
                                name="name"
                                className="text-input"
                              />
                            </div>

                            <div className="clearfix form-row" />

                            <div className="col-lg-12 col-sm-12">
                              <label>کد کالا</label>

                              <input
                                type="text"
                                onChange={e => {
                                  setFieldValue(
                                    'extraCode',
                                    parseInt(e.target.value, 0)
                                  )
                                }}
                                value={
                                  values && values.extraCode
                                    ? values.extraCode
                                    : ''
                                }
                                name="extraCode"
                                className="text-input"
                              />
                            </div>

                            <div className="col-lg-6 col-sm-12">
                              <label>کد سفارش</label>

                              <DecimalInput
                                type="tel"
                                value={
                                  values && values.taskCode
                                    ? values.taskCode
                                    : undefined
                                }
                                onChange={e => {
                                  setFieldValue('taskCode', e.target.value)
                                }}
                                className="text-input"
                              />
                            </div>

                            <div className="col-lg-6 col-sm-12">
                              <label>تاریخ سفارش</label>

                              <DatePicker
                                onChange={e => {
                                  setFieldValue('date', e)
                                }}
                                value={values && values.date ? values.date : ''}
                                name="date"
                                className="text-input"
                              />
                            </div>

                            <div className="clearfix form-row" />

                            <div className="col-md-12">
                              <button
                                type="submit"
                                className="btn btn-primary btn-block"
                                disabled={isSubmitting}>
                                {loading ? (
                                  <i className="mdi mdi-spin mdi-loading" />
                                ) : (
                                  <i className="mdi mdi-magnify" />
                                )}
                                &nbsp; جستجو &nbsp;
                              </button>
                              {/* <a className="btn btn-primary" 
                    onClick={() => {
                      setFieldValue('travelBrandId', undefined);
                      resetForm({
                        travelBrandId: undefined, transporterId: '', khodroId: '',
                        cityId: '', originTerminalId: '', destinationCityId: '', destinationTerminalId: '', tripClass: '', price: ''
                      })
                      // console.log(values);

                    }}
                  >
                    <i className="mdi mdi-playlist-check"></i>&nbsp;حذف همه فیلترها
                  </a> */}
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                )
              }}
            </Formik>
          </DialogContent>
        </Dialog>

        <Dialog
          open={this.state.modal}
          onClose={this.handleModalHide}
          TransitionComponent={Transition}
          scroll={'paper'}
          fullScreen={true}
          // maxWidth="lg"
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description">
          <DialogTitle>
            <Fab
              color="secondary"
              aria-label="refresh"
              size="small"
              onClick={() => this.handleModalHide()}
              className="modal-close-btn">
              <MdClose size="20px" />
            </Fab>
            <span style={{ marginRight: 10 }} />
          </DialogTitle>
          <DialogContent dividers={true} style={{ minHeight: 225 }}>
            <Form
              onSubmit={() => this.handleModalClose()}
              id={this.state.model.id}
              taskType={this.state.taskType}
              categoryType={this.props.categoryType}
              onClose={() => this.handleModalClose()}
              isModal={true}
            />
          </DialogContent>
        </Dialog>

        <MySweetAlert
          show={this.state.confirmDeleteShow}
          onCancel={this.handleSweetAlertHide}
          onConfirm={this.handleConfirmDelete}
          title={
            'آیا از حذف کالا  [' + this.state.model.name + '] مطمئن هستید؟'
          }
        />

        {loading ? <Loading /> : ''}
      </div>
    )
  }
}

class ClumTasks extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      activeTab: 'tasks'
    }
  }
  render() {
    const { activeTab } = this.state
    return (
      <Tabs
        transition={false}
        id="controlled-tab-example"
        activeKey={activeTab}
        onSelect={activeTab => this.setState({ activeTab })}>
        <Tab eventKey="tasks" taskStatus={0} title="سفارشات جدید">
          {activeTab === 'tasks' ? (
            <DataTable unitTaskStatus={0} categoryType={1} />
          ) : (
            ''
          )}
        </Tab>
        <Tab eventKey="assignedTasks" taskStatus={1} title="ارجاع شده">
          {activeTab === 'assignedTasks' ? (
            <DataTable unitTaskStatus={1} categoryType={1} />
          ) : (
            ''
          )}
        </Tab>
        <Tab eventKey="inProgressTasks" taskStatus={1} title="در حال انجام">
          {activeTab === 'inProgressTasks' ? (
            <DataTable unitTaskStatus={2} categoryType={1} />
          ) : (
            ''
          )}
        </Tab>
        <Tab eventKey="completedTasks" taskStatus={2} title="تکمیل شده">
          {activeTab === 'completedTasks' ? (
            <DataTable unitTaskStatus={3} categoryType={1} />
          ) : (
            ''
          )}
        </Tab>
        {/* <Tab eventKey="productExit" title="خروج کالا">
        {activeTab === 'productExit' ?
          <ProductOperationsList unitProductOperationType={1} />
          : ''}
      </Tab> */}
      </Tabs>
    )
  }
}

function mapStateToProps(state) {
  const { authentication } = state
  const { user } = authentication
  return {
    user
  }
}
const connectedClumTasks = connect(mapStateToProps)(ClumTasks)
export { connectedClumTasks as ClumTasks }
